import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { observer } from 'mobx-react'
import Router from 'next/router'

import AlertDialog from 'components/AlertDialog'
import useCouponUsedPusher from 'hooks/useCouponUsedPusher'

const PusherAlert = observer(() => {
  const couponUsedEventData = useCouponUsedPusher()
  const [openAlert, setOpenAlert] = useState(false)
  const alertDescription = useMemo(() => {
    if (couponUsedEventData) {
      const { sku } = couponUsedEventData
      return `${sku.merchant.name} - ${sku.name}`
    }
  }, [couponUsedEventData])
  const handleCloseAlert = useCallback(() => setOpenAlert(false), [])
  const redirectToCouponDetail = useCallback(
    () =>
      Router.push(
        `/coupon?id=${couponUsedEventData.couponId}`,
        `/coupon/${couponUsedEventData.couponId}`
      ),
    [couponUsedEventData]
  )
  useEffect(() => {
    if (couponUsedEventData) {
      setOpenAlert(true)
    }
  }, [couponUsedEventData])

  return (
    <AlertDialog
      open={openAlert}
      handleClose={handleCloseAlert}
      title={'優惠券已使用'}
      description={alertDescription}
      leftButtonText={'關閉'}
      rightButtonText={'查看優惠券'}
      onLeftButtonClick={handleCloseAlert}
      onRightButtonClick={redirectToCouponDetail}
    />
  )
})

export default PusherAlert
